import React, { useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import axios from 'axios';
import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { getContent } from '../../api';

export default function PasswordRecover() {
  const { t } = useTranslation();
  const history = useHistory();
  const [state, setState] = useState('');
  const [password, setPassword] = useState();
  const [rePassword, setRePassword] = useState();
  const [error, setError] = useState(' ');
  const [logo, setLogo] = useState(null);
  const { token } = useParams();

  const submit = async (e) => {
    e.preventDefault();

    try {
      const request = { password, rePassword };
      await axios.post(
        `${process.env.REACT_APP_API_URI}/api/password_recover/${token}`,
        request,
      );
      setState('success');
    } catch (err) {
      setError(err.response.data.message);
    }
  };

  useEffect(() => {
    getContent()
      .then((res) => {
        setLogo(res.data.main[1].image);
      })
      .catch();
  }, []);

  if (state === 'success') {
    return (
      <div className="container d-flex mt-5">
        <div className="mx-4 w-100">
          <div className="w-100">
            <div className="login-logo">
              <img src={`${process.env.REACT_APP_API_URI}/api/image/${logo}`} alt="" width="179" height="120" />
            </div>
            <h2 className="text-center title">Recuperar Password</h2>
            <p className="text-center text">
              Palavra Passe Recuperada Com Sucesso
            </p>
            <div className="text-center mt-5">
              <a href="/">
                <button type="button" className="green-button">HomePage</button>
              </a>
            </div>
            <div className="text-center mt-2">
              <a href="/login">
                <button type="button" className="green-button">LoginPage</button>
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="login">
      <button type="button" className="go-back-button" onClick={() => { history.goBack(); }}>
        {t('goBack')}
      </button>
      <div className="d-flex flex-wrap vertical-align justify-content-center mb-5 mt-5">
        <div className="">
          <div className="login-input">
            <div className="login-logo">
              <img src={`${process.env.REACT_APP_API_URI}/api/image/${logo}`} alt="" width="179" height="120" />
            </div>
            <div className="d-flex flex-wrap vertical-align justify-content-center mt-5">
              <h1 className="my-auto font-weight-bold title-404 text-center title">Recuperar Password</h1>
            </div>
            <Form className="login-form" action="" method="post" onSubmit={submit}>
              <Form.Group>
                <Form.Label htmlFor="password">Password</Form.Label>
                <Form.Control
                  type="password"
                  name="password"
                  id="password"
                  pattern=".{6,}"
                  required
                  onChange={(e) => setPassword(e.target.value)}
                />
              </Form.Group>
              <Form.Group>
                <Form.Label htmlFor="confirmPassword">Confirm Password</Form.Label>
                <Form.Control
                  type="password"
                  name="confirmPassword"
                  id="confirmPassword"
                  pattern=".{6,}"
                  required
                  onChange={(e) => setRePassword(e.target.value)}
                />
              </Form.Group>
              <div><small className="text-danger pre-wrap">{error}</small></div>
              <Form.Group className="login-row">
                <input type="submit" className="green-button" value="Submeter" />
              </Form.Group>
            </Form>

          </div>
        </div>
      </div>
    </div>
  );
}
